import * as React from 'react';
import { VeriLiteInformationEvent, IVeriLiteEvent, IReportRow, IPackInfo } from '../../Types';
import { Table } from 'reactstrap';
import {CopyText } from '../../Pages/Dashboard/Pages/Reports/Components';

export const PackDetailsInformationEvent = (resources: any, request: IReportRow, pack: IPackInfo): VeriLiteInformationEvent => {
    return new VeriLiteInformationEvent(
        <Details resources={resources} request={request} pack={pack} />,
        resources.PackDetails,
        []
    );
};

interface IDetailsProps {
    resources: any;
    request: IReportRow;
    pack: IPackInfo;
}

export class Details extends React.Component<IDetailsProps, any>{
    constructor(props: IDetailsProps) {
        super(props);
    }
    
    render() {
        return (
            <Table size="sm" bordered>
                <tbody>
                    <tr>
                        <th scope="row">{this.props.resources.User}</th>
                        <td>{this.props.request?.userInfo?.DisplayName} ({this.props.request?.userInfo?.Email})</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.Action}</th>
                        <td>{this.props.request.additionalInfo.action}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.ProductCode}</th>
                        <td>{this.props.pack.productCode}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.SerialNumber}</th>
                        <td>{this.props.pack.serialNumber}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.BatchID}</th>
                        <td>{this.props.pack.batchId}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.ExpiryDate}</th>
                        <td>{this.props.pack.expiryDate}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.PackState}</th>
                        <td>{this.props.pack.packState}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.Status}</th>
                        <td>{this.props.pack.status}</td>
                    </tr>
                    <tr>
                        <th scope="row">{this.props.resources.Message || "Message"}</th>
                        <td>{this.props.pack.information || this.props.pack.warning}</td>
                    </tr>
                    {(this.props.pack.productName || this.props.request.additionalInfo.productName)&& <tr>
                        <th scope="row">{this.props.resources.ProductName}</th>
                        <td>{this.props.pack.productName ?? this.props.request.additionalInfo.productName}</td>
                        </tr>
                        }
                    {this.props.pack.uprc && <tr>
                        <th scope="row">{this.props.resources.UPRC}</th>
                        <td>{this.props.pack.uprc}</td>
                    </tr>}
                    {this.props.pack.AmsLink && <tr>
                        <th scope="row">{this.props.resources.AmsLink}</th>
                        <td>{this.props.pack.AmsLink} <CopyText copyTarget={this.props.pack.AmsLink} resources={this.props.resources} /></td>
                    </tr>}
                    {this.props.pack.AlertCode && <tr>
                        <th scope="row">{this.props.resources.AlertCode}</th>
                        <td>{this.props.pack.AlertCode}</td>
                    </tr>}
                    {this.props.pack.Nhrn && <tr>
                        <th scope="row">{this.props.resources.Nhrn}</th>
                        <td>{this.props.pack.Nhrn}</td>
                    </tr>}
                    {this.props.pack.OperationCode && <tr>
                        <th scope="row">{this.props.resources.OperationCode}</th>
                        <td>{this.props.pack.OperationCode}</td>
                    </tr>}

                </tbody>
            </Table>
        );
    }
}